var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7067 14.2968L12.6099 11.1987C14.9271 8.10223 14.2953 3.71356 11.1987 1.39641C8.10223 -0.920736 3.71356 -0.288925 1.39641 2.80759C-0.920736 5.90411 -0.288925 10.2928 2.80759 12.6099C5.29497 14.4713 8.71134 14.4713 11.1987 12.6099L14.2968 15.708C14.6861 16.0973 15.3174 16.0973 15.7067 15.708C16.096 15.3187 16.096 14.6875 15.7067 14.2982L15.7067 14.2968ZM7.02899 12.012C4.27695 12.012 2.04601 9.78103 2.04601 7.02899C2.04601 4.27695 4.27695 2.04601 7.02899 2.04601C9.78102 2.04601 12.012 4.27695 12.012 7.02899C12.009 9.77978 9.77981 12.009 7.02899 12.012Z",
    fill: "#5A5B61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.551890ef3c26975e9d2f2be7963f58d8.svg";
export { ForwardRef as ReactComponent };